export const elTableHeaderCellStyle = () => {
    return {
        background: '#fafafa',
        color: '#333',
        fontSize: '13px'
    }
}
